import PropTypes from 'prop-types';

const propType = {
  tag: PropTypes.string,
};

export default { propType };
